export enum NotificationDuration {
  atTime = 1,
  day = 1440,
  halfHour = 30,
  hour = 60,
  hours3 = 180,
  minutes15 = 15,
  noNotify = 0,
}

export const NotificationDurationArray = [
  NotificationDuration.noNotify,
  NotificationDuration.atTime,
  NotificationDuration.minutes15,
  NotificationDuration.halfHour,
  NotificationDuration.hour,
  NotificationDuration.hours3,
  NotificationDuration.day,
] as const;

export const NotificationDurationLabels = {
  [NotificationDuration.atTime]:
    'all:event.notifications.duration_labels.atTime',
  [NotificationDuration.day]: 'all:event.notifications.duration_labels.day',
  [NotificationDuration.halfHour]:
    'all:event.notifications.duration_labels.halfHour',
  [NotificationDuration.hour]: 'all:event.notifications.duration_labels.hour',
  [NotificationDuration.hours3]:
    'all:event.notifications.duration_labels.hours3',
  [NotificationDuration.minutes15]:
    'all:event.notifications.duration_labels.minutes15',
  [NotificationDuration.noNotify]:
    'all:event.notifications.duration_labels.noNotify',
} as const;
